import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { AdminRoutingModule } from './admin-routing.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import { AlertModule } from '../alert/alert.module';
import {AdminTemplateComponent,RejectDialog} from './admin-template/admin-template.component';
import { PostHub } from './social-hub/post-hub/post-hub.component';
import {CreateCompetition} from './social-hub/create-competition/create-competition.component'
import {AdminBotComponent} from './admin-bot/admin-bot.component';
import { SocialHubMain, ResheduleDialog, DeleteDialog } from './social-hub/social-hub-main.component';
import { CompetitionInfo } from './social-hub/competition-info/competition-info.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import { CreatePost, AddVideoLink } from './social-hub/create-post/create-post.component';
import { CompetitionEntry, PreviewPopUp, DeclareResult, SheduleDialog } from './social-hub/competition-entry/competition-entry.component';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatCardModule} from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import {MatSelectModule} from '@angular/material/select';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MerchantDashboardComponent } from './merchant-dashboard/merchant-dashboard.component';
import {MatTabsModule} from '@angular/material/tabs';
import { AdminKycVerificationComponent } from './admin-kyc-verification/admin-kyc-verification.component';
import {BusinessRejectDialog,PreviewDialog,ApprovalDialog} from './admin-kyc-verification/admin-kyc-verification.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DraftDialog } from './social-hub/create-competition/create-competition.component';
import { LibModule } from '../lib/lib.module';
import {MatPaginatorModule} from '@angular/material/paginator';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import {MatRadioModule} from '@angular/material/radio';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { PostDetail } from './social-hub/post-detail/post-detail.component';
import { ListBanner } from './create-miniapps/list-banner/list-banner';
import { CreateBanner } from './create-miniapps/create-banner/create-banner';
import { BannerList,DeactivateBannerDialog,RescheduleBannerDialog } from './banner-hub/banner-list/banner.list.component'
import { BannerCreate } from './banner-hub/banner-create/banner.create.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { CertificateGenerate } from './social-hub/competition-entry/certificate/certificate.component';
import { AdminMiniappComponent } from './admin-mini-app/admin-miniapp.component'
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ClipboardModule } from 'ngx-clipboard';
@NgModule({
    declarations: [
        AdminComponent,
        AdminTemplateComponent,
        AdminBotComponent,
        AdminMiniappComponent,
        SocialHubMain,
        RejectDialog,
        MerchantDashboardComponent,
        AdminKycVerificationComponent,
        BusinessRejectDialog,
        PreviewDialog,
        ApprovalDialog,
        ResheduleDialog,
        CompetitionInfo,
        CompetitionEntry,
        CreateCompetition,
        PreviewPopUp,
        DeclareResult,
        SheduleDialog,
        DraftDialog,
        CreatePost,
        PostHub,
        AddVideoLink,
        PostDetail,
        ListBanner,
        CreateBanner,
        BannerList,
        BannerCreate,
        DeleteDialog,
        BannerCreate,
        CertificateGenerate,
        DeactivateBannerDialog,
        RescheduleBannerDialog
    ],
    imports: [
        CommonModule,
        AdminRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        MatIconModule,
        MatInputModule,
        NgxSliderModule,
        MatToolbarModule,
        MatMenuModule,
        MatButtonModule,
        AlertModule,
        MatCardModule,
        MatListModule,
        MatCheckboxModule,
        MatRippleModule,
        TooltipModule,
        ClipboardModule,
        MatTabsModule,
        NgbModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSelectModule,
        MatFormFieldModule,
        MatPaginatorModule,
        LibModule,
        MatRadioModule,
        CKEditorModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule
    ]
})
export class AdminModule { }
